"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _LineChart = _interopRequireDefault(require("@rsuite/icon-font/lib/charts/LineChart"));

// Generated by script, don't edit it please.
var LineChart = (0, _createSvgIcon["default"])({
  as: _LineChart["default"],
  ariaLabel: 'line chart',
  category: 'charts',
  displayName: 'LineChart'
});
var _default = LineChart;
exports["default"] = _default;
module.exports = exports.default;